var _filter, _filter2, _rect, _g, _circle, _circle2, _g2, _g3, _g4, _text, _text2, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f172a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#1e1b4b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f172a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcpGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2aGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "toolGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#16a34a"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 1200,
    y2: 100,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 1200,
    y2: 200,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 1200,
    y2: 300,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 400,
    x2: 1200,
    y2: 400,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 500,
    x2: 1200,
    y2: 500,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 630,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 630,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 630,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 630,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 0,
    x2: 1000,
    y2: 630,
    stroke: "white",
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 200,
    fill: "#3b82f6",
    opacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 480,
    r: 250,
    fill: "#ec4899",
    opacity: 0.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 315)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 70,
    fill: "url(#mcpGradient)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "70;75;70",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -12,
    r: 10,
    fill: "white",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.9;0.5;0.9",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: -12,
    r: 10,
    fill: "white",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.9;0.5;0.9",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 12,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110, -60)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -25,
    width: 50,
    height: 50,
    rx: 8,
    fill: "url(#toolGrad)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "API")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -25,
    width: 50,
    height: 50,
    rx: 8,
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "DB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -25,
    width: 50,
    height: 50,
    rx: 8,
    fill: "#ef4444"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "File")), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: -30,
    x2: 85,
    y2: -50,
    stroke: "#22c55e",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,50;25,50;0,50",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 15,
    x2: 100,
    y2: 25,
    stroke: "#f59e0b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,50;25,50;0,50",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 70,
    y2: 80,
    stroke: "#ef4444",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,50;25,50;0,50",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 130,
    textAnchor: "middle",
    fill: "#3b82f6",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 28
  }, "MCP"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 155,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 14
  }, "Agent to Tools"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 315)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 50,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 12,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 32
  }, "VS"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 315)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -60,
    cy: 0,
    r: 55,
    fill: "url(#a2aGradient)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "55;60;55",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -72,
    cy: -10,
    r: 8,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -48,
    cy: -10,
    r: 8,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -75,
    y: 8,
    width: 30,
    height: 6,
    rx: 3,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 55,
    fill: "url(#a2aGradient)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "55;60;55",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: -10,
    r: 8,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: -10,
    r: 8,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 8,
    width: 30,
    height: 6,
    rx: 3,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -10,
    x2: 5,
    y2: -10,
    stroke: "#8b5cf6",
    strokeWidth: 4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "5;5;5",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10,
    x2: -5,
    y2: 10,
    stroke: "#ec4899",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#8b5cf6",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "-5;5",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "-10;-10",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#ec4899",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "5;-5",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "10;10",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#a855f7",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;30;10",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0;0.6",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 130,
    textAnchor: "middle",
    fill: "#a855f7",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 28
  }, "A2A"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 155,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 14
  }, "Agent to Agent"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 100,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 56,
    filter: "url(#softGlow)"
  }, "MCP vs A2A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 140,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 22
  }, "Understanding AI Agent Communication Protocols")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 580,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, sans-serif",
    fontSize: 16
  }, "Tools or Collaboration? Choose the right protocol for your AI agents.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.1da2a7d677c7d4058ed73f882bfc093c.svg";
export { ForwardRef as ReactComponent };